const isDevelopment = process.env.NODE_ENV === "development";

export function getGoAccountsApiURL(): string {
	if (process.env.REACT_APP_GOACCOUNTS_URL) {
		return process.env.REACT_APP_GOACCOUNTS_URL;
	}
	return "http://app.goaccounts.local";
}

export function getApiURL(): string {
	if (process.env.REACT_APP_API_URL) {
		return process.env.REACT_APP_API_URL;
	}
	return "http://app.gopos.local";
}

export function getTokenClientId(): string {
	if (process.env.REACT_APP_CLIENT_ID) {
		return process.env.REACT_APP_CLIENT_ID;
	}

	return "16a056f6-b6f6-45f1-bd22-4561df5bc7c6";
}

export function getTokenClientSecret(): string {
	if (process.env.REACT_APP_CLIENT_SECRET) {
		return process.env.REACT_APP_CLIENT_SECRET;
	}

	return "aab7ad66-c79d-11eb-b8bc-0242ac130003";
}

export function getSentryDSN() {
	if (process.env.REACT_APP_SENTRY_DSN) {
		return process.env.REACT_APP_SENTRY_DSN;
	}

	return "";
}

export function getGoogleAnalyticsId(): string | undefined {
	if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) {
		return process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
	}
	return undefined;
}

export function getNotificationTemplate(): string | undefined {
	if (isDevelopment) return "true";

	return process.env.REACT_APP_NOTIFICATION_TEMPLATE;
}

export function getCreatingDeliveryZones(): string | undefined {
	if (isDevelopment) return "true";

	return process.env.REACT_APP_CREATING_DELIVERY_ZONES;
}

export function getSubscriptionBasedRestrictions(): string | undefined {
	if (isDevelopment) return "true";

	return process.env.REACT_APP_SUBSCRIPTION_BASED_RESTRICTIONS;
}

export function employeeTipsEnabled(): string | undefined {
	if (isDevelopment) return "true";

	return process.env.REACT_APP_EMPLOYEE_TIPS;
}

export function terminalsUpgradeEnabled(): string | undefined {
	if (isDevelopment) return "true";

	return process.env.REACT_APP_TERMINALS_UPGRADE;
}

export function paymentEnvironment(): google.payments.api.Environment {
	return (process.env?.REACT_APP_PAYMENT_ENVIRONMENT as google.payments.api.Environment) ?? "TEST";
}

export function gatewayMerchantId(): string {
	return process.env?.REACT_APP_GATEWAY_MERCHANT_ID ?? "";
}

export function googlePayEnvironment(): string | undefined {
	return process.env?.REACT_APP_GOOGLE_PAY_ENVIRONMENT;
}
